import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import {
  ButtonCancel,
  ButtonLink,
  ButtonRequest,
  CalendarCoach,
  CardDayAvailable,
  CoachCard,
  CoachDescription,
  CoachTitle,
  ContentDescriptLang,
  DateAvailable,
  GeneralAvailabilityMyCoach,
  HourAvailable,
  HR,
  ImageCoach,
  TitleOfToday,
} from "./MyCoachAvailability.styled";
import coachPhoto from "../../assets/image-not-available.png";
import Flag from "react-flagkit";
import { useLocation } from "react-router-dom";
import moment from "moment";
import "react-calendar/dist/Calendar.css";
import Calendar from "react-calendar";
import { getFile } from "../../services/FileManager";
import PropTypes from "prop-types";

const MyCoachAvailability = ({
  userData,
  coachAvailable,
  valueOfCalendar,
  setValueOfCalendar,
  requestAvailability,
  handleCancel,
  handleSeeDetail,
}) => {
  const location = useLocation();
  const [activeCard, setActiveCard] = useState({});
  const [coach, setCoach] = useState(location.state.coach);
  const [defaultValueCalendar] = useState(new Date());
  const [calendar] = useState(valueOfCalendar);
  const [appointment, setAppointment] = useState({});
  const [previewImage, setPreviewImage] = useState();
  useEffect(() => {
    if (coach?.coverImage) {
      getFile(coach.coverImage).then((response) => {
        if (response && response.type !== "archivo-noexistente/json") {
          setPreviewImage(URL.createObjectURL(response));
        }
      });
    } else {
      setPreviewImage(coachPhoto);
    }
  }, [coach]);

  useEffect(() => {
    if (coachAvailable) {
      setCoach(coachAvailable);
    }
  }, [coachAvailable]);

  let coachStartDate = () => {
    if (coach?.turnsAvailable?.length > 0 && activeCard.startDate !== undefined) {
      return moment(activeCard.startDate + " " + activeCard.startTime).format();
    }
    return null;
  };

  let coachEndDate = () => {
    if (coach?.turnsAvailable?.length > 0 && activeCard.endDate !== undefined) {
      return moment(activeCard.endDate + " " + activeCard.endTime).format();
    }
    return null;
  };

  useEffect(() => {
    if (userData && coach && activeCard) {
      setAppointment({
        eventName: "Requested counselling",
        eventDescription: "Requested counselling",
        eventType: "PRIVATE",
        eventStatus: "ACTIVE",
        groups: [],
        photoUri: "",
        speakers: [],
        eventUri: "",
        languageId: coach?.wellnessCoachesLanguages[0]?.idLanguage,
        cityId: coach.cityId,
        countryId: coach.countryId,
        eventCategoryId: 1,
        startDate: coachStartDate(),
        finishDate: coachEndDate(),
        individualGuests: [coach?.userId, userData?.userId],
        participantIsRequired: true,
        participantsLimit: null,
      });
    }
  }, [userData, coach, activeCard]);

  return (
    <GeneralAvailabilityMyCoach>
      <Row>
        <Col md={3}>
          <CalendarCoach>
            <Calendar
              defaultValue={defaultValueCalendar}
              onChange={setValueOfCalendar}
              value={calendar}
            />
          </CalendarCoach>
        </Col>
        <Col md={9} className="mt-3">
          <CoachCard>
            <Row>
              <Col md={2} className="px-md-3 px-lg-5 pt-3">
                <ImageCoach previewImage={previewImage} />
              </Col>
              <Col md={8} className="px-4 pt-3 pb-0">
                <CoachTitle>
                  {coach?.firstName + " " + coach?.lastName}
                </CoachTitle>
                <CoachDescription>{coach?.description}</CoachDescription>
                <ContentDescriptLang>
                  Languages:
                  {coach?.wellnessCoachesLanguages &&
                    coach?.wellnessCoachesLanguages?.length > 0 &&
                    coach?.wellnessCoachesLanguages?.map((item, index) => {
                      return (
                        <Flag
                          key={index}
                          style={{ borderRadius: "99px" }}
                          className="mx-1"
                          country={`${
                            item?.idLanguage === "en"
                              ? "US"
                              : item?.idLanguage.toUpperCase()
                          }`}
                        />
                      );
                    })}
                </ContentDescriptLang>
              </Col>
              <Col md={2} className="d-flex align-items-center">
                <ButtonLink onClick={handleSeeDetail} className="btn btn-link">
                  See detail
                </ButtonLink>
              </Col>
            </Row>
            <HR />
            <Row className="ml-1 mr-4">
              <Col md={12}>
                <TitleOfToday>
                  {`${
                    valueOfCalendar
                      ? moment(valueOfCalendar, "YYYY/MM/DD").format(
                          "YYYY/MM/DD"
                        )
                      : moment().format("YYYY/MM/DD")
                  }`}
                </TitleOfToday>
              </Col>

              {coach?.turnsAvailable.length > 0 ? (
                coach?.turnsAvailable.map((element, index) => {
                    return (
                      <>
                        <Col md={2} key={index}>
                          <CardDayAvailable
                            id={index}
                            activeCard={activeCard}
                            onClick={() => {
                              let startDate = moment.utc(element.start).toDate();
                              let startEnd = moment.utc(element.end).toDate();
                              setActiveCard({
                                id: index,
                                active: index === activeCard.id ? true : false,
                                startDate: moment(startDate).format(
                                  "YYYY/MM/DD"
                                ),
                                endDate: moment(startEnd).format(
                                  "YYYY/MM/DD"
                                ),
                                startTime: moment(element.start).format(
                                  "hh:mm a"
                                ),
                                endTime: moment(element.end).format(
                                  "hh:mm a"
                                ),
                              });
                            }}
                          >
                            <DateAvailable hidden={true}>{`${moment(
                              element.start,
                              "YYYY/MM/DD"
                            ).format("YYYY/MM/DD")}`}</DateAvailable>
                            <HourAvailable>{`${moment(element.start).format(
                              "hh:mm a"
                            )}`}</HourAvailable>{" "}
                            to{" "}
                            <HourAvailable>{`${moment(element.end).format(
                              "hh:mm a"
                            )}`}</HourAvailable>
                          </CardDayAvailable>
                        </Col>
                      </>
                    );
                  })
              ) : (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <h4>There are not slots available for this day</h4>
                </div>
              )}
              {coach?.turnsAvailable.length > 0 && (
                <Col md={12}>
                  <div
                    style={{
                      display: "flex",
                      marginLeft: "1em",
                    }}
                  >
                    <ButtonRequest
                      onClick={() => requestAvailability(appointment)}
                    >
                      Request
                    </ButtonRequest>
                    <ButtonCancel onClick={() => handleCancel()}>
                      Cancel
                    </ButtonCancel>
                  </div>
                </Col>
              )}
              <br />
            </Row>
          </CoachCard>
        </Col>
      </Row>
    </GeneralAvailabilityMyCoach>
  );
};

export default MyCoachAvailability;

MyCoachAvailability.propTypes = {
  userData: PropTypes.object,
  coachAvailable: PropTypes.object,
  valueOfCalendar: PropTypes.string,
  setValueOfCalendar: PropTypes.func,
  requestAvailability: PropTypes.func,
  handleCancel: PropTypes.func,
  handleSeeDetail: PropTypes.func,
}